import { Pencil, PiggyBank, Tag } from '@phosphor-icons/react';

import pt from '../../locales/pt';
import { cn } from '../../utils/cn';
import { MoneyDisplay } from '../common/MoneyDisplay';
import { formatEUR } from '../../utils/money';

/**
 * Linha de categoria na lista do grupo — toque abre o cartão de foco (Camada 3).
 * O valor abre o dialog de ajuste (fallback acessibilidade).
 */
export function CategoryBudgetSliderRow({
  category,
  canEditBudgets,
  onAdjustDialog,
  onFocus,
  className,
}) {
  const isPot = Boolean(category.is_smoothing_pot);
  const budget =
    category.budget_eur !== null && category.budget_eur !== undefined
      ? Number(category.budget_eur)
      : 0;
  const average =
    category.average_spent_eur != null
      ? Number(category.average_spent_eur)
      : null;

  return (
    <div className={cn('border-b border-border py-space-3 last:border-b-0', className)}>
      <div className="flex items-center gap-space-3">
        <button
          type="button"
          onClick={() => {
            if (!isPot) onFocus?.(category);
          }}
          disabled={isPot}
          className="flex min-w-0 flex-1 items-center gap-space-3 text-left disabled:cursor-default"
        >
          <span
            className="flex h-7 w-7 shrink-0 items-center justify-center rounded-ds-sm"
            style={{ backgroundColor: `${category.category_color || '#7C9E6F'}22` }}
          >
            {isPot ? (
              <PiggyBank
                className="h-4 w-4"
                style={{ color: category.category_color || '#7C9E6F' }}
                aria-hidden
              />
            ) : (
              <Tag
                className="h-4 w-4"
                style={{ color: category.category_color || '#7C9E6F' }}
                aria-hidden
              />
            )}
          </span>
          <span className="flex min-w-0 flex-1 flex-col gap-px">
            <span
              className="type-body-sm truncate font-semibold text-foreground"
              title={category.category_name}
            >
              {category.category_name}
            </span>
            {average != null ? (
              <span className="type-chip truncate font-normal text-muted-foreground">
                {pt.budget.groupRefs.averageAmount.replace('{amount}', formatEUR(average))}
              </span>
            ) : null}
          </span>
        </button>
        <MoneyDisplay value={budget} size="sm" className="type-display-row shrink-0" />
        {canEditBudgets && !isPot ? (
          <button
            type="button"
            onClick={() => onAdjustDialog?.(category)}
            className="flex h-7 w-7 shrink-0 items-center justify-center rounded-ds-full bg-muted text-muted-foreground transition-colors hover:bg-stone-200 dark:hover:bg-stone-700"
            aria-label={pt.budget.categories.adjustCta}
          >
            <Pencil className="h-3.5 w-3.5" aria-hidden />
          </button>
        ) : null}
      </div>
    </div>
  );
}
